import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import formStyles from 'pages/Form.module.css';
import styles from 'pages/Login.module.css';
import globalStyles from 'Global.module.css';
import { LoginDocument } from 'graphql/mutations.generated';
import { useMutation } from '@apollo/client/react';

const Login: React.FC = () => {
  const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

    const [loginMutation, { loading }] = useMutation(LoginDocument);

  const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
    setError('');

    try {
        const result = await loginMutation({
            variables: {
          login,
          password,
            },
      });

        if (result.data?.login) {
            // Handle successful login
            navigate('/browse-events');
        } else {
        throw new Error('Login failed');
        }
    } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
    }
  };

  return (
    <div className={formStyles.formContainer}>
      <h1>Login</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="login">Login:</label>
          <input
            type="text"
            id="login"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <div className={formStyles.error}>{error}</div>}
              <button type="submit" disabled={loading} className={globalStyles.submitButton}>
                  {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      <div className={styles.registerContainer}>
        Don't have an account? <Link to="/register">Create one</Link>
      </div>
    </div>
  );
};

export default Login;